module.exports = __webpack_public_path__ + "static/media/whiteCheck.373f197f.svg";